import { createAction, createReducer, createSelector } from '@reduxjs/toolkit'

const handleFetchProperties = createAction('properties/fetch')
export const handleReceiveProperties = createAction('properties/receive')
export const handleErrorProperties = createAction('properties/error')

const initialState = {
  loading: false,
  data: null,
  error: null,
}

export const propertiesReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(handleFetchProperties, (state) => {
      state.loading = true
    })
    .addCase(handleReceiveProperties, (state, action) => {
      state.loading = false
      state.data = action.payload
    })
    .addCase(handleErrorProperties, (state, action) => {
      state.loading = false
      state.error = action.payload
    })
})
const selectPropertyState = (state) => state.properties

export const selectProperties = createSelector(
  selectPropertyState,
  (state) => state.data || {}
)
